import { trackEvent } from '../../modules/analytics';

const BASE_ATTRIBUTES = { location: 'settings' };

const trackUpdateCoverArtClick = () => {
  trackEvent('update_cover_art_button_clicked', BASE_ATTRIBUTES, {
    providers: [mParticle],
  });
};

const trackRedirectEvents = () => {
  trackEvent(
    'redirect_rss_distribution_button_clicked',
    { location: 'podcast_availability' },
    { providers: [mParticle] }
  );
};

export { trackUpdateCoverArtClick, trackRedirectEvents };
